// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const StarsOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_2821)"},"children":[{"tag":"path","attrs":{"d":"M11.99 2A10 10 0 1012 21.99 10 10 0 0011.99 2zm7.48 7.16l-5.01-.43-2-4.71a8.03 8.03 0 017.01 5.14zm-5.07 6.26L12 13.98l-2.39 1.44.63-2.72-2.11-1.83 2.78-.24L12 8.06l1.09 2.56 2.78.24-2.11 1.83.64 2.73zm-2.86-11.4l-2 4.72-5.02.43a8 8 0 017.02-5.15zM4 12c0-.64.08-1.26.23-1.86l3.79 3.28-1.11 4.75A7.98 7.98 0 014 12zm3.84 6.82L12 16.31l4.16 2.5a7.92 7.92 0 01-8.32.01zm9.25-.65l-1.11-4.75 3.79-3.28a8.01 8.01 0 01-2.68 8.03z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_2821"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"#fff"}}]}]}]},"name":"stars","theme":"outlined"};

const StarsOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={StarsOutlinedSvg} />;
  StarsOutlined.displayName = 'StarsOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(StarsOutlined);
